import { ModuleModeEnum } from '@/enums/ModuleModeEnum';

export default {
    indicator: ({ values }: { values: { mode: ModuleModeEnum } }) => {
        const { mode } = values;
        return `Hãy đọc to phần được đánh dấu.
                    ${mode === ModuleModeEnum.SELF ? 'Nhấp vào đoạn văn để di chuyển đoạn.' : ''}`;
    },
    intro: {
        content: {
            loud: 'Hãy đọc to phần được đánh dấu!',
            readingType1: 'Hãy cùng nhau đọc có hướng dẫn theo {readingType}.',
            readingType2: 'Hãy đọc có hướng dẫn theo {readingType}.',
            teacherAndStudents: 'Giáo viên hãy đọc to phần màu vàng, Học sinh hãy đọc to phần màu xanh!',
            start: 'Hãy bắt đầu Đọc có hướng dẫn theo {readingType} nhé?',
            students: '{students} hãy đọc to phần được đánh dấu nhé!',
        },
        othersCount: 'và {count} người khác',
    },
    options: {
        title: 'Tiêu đề',
        readingType: {
            label: 'Đơn vị đọc',
            unit: 'Đơn vị',
            meaning: 'Ý nghĩa',
            sentence: 'Câu',
            paragraph: 'Đoạn văn',
        },
        readingMode: {
            label: 'Cách đọc',
            all: 'Đọc toàn bộ',
            split: 'Đọc chia nhỏ',
            random: 'Đọc luân phiên (ngẫu nhiên)',
            selected: 'Đọc luân phiên (chỉ định)',
        },
        example: { all: 'Tất cả cùng nhau', teacher: 'Giáo viên', students: 'Học sinh' },
        textbook: 'Đoạn văn trong sách giáo khoa',
    },
    setting: {
        readerCount: 'Số học sinh đọc',
        draw: 'Bốc',
        redraw: 'Bốc lại',
        resetSelection: 'Đặt lại lựa chọn',
        randomOrderNotice: 'ⓘ Thứ tự được sắp xếp ngẫu nhiên.',
        connectedCount: '{count} trực tuyến',
        personCount: '{count}',
        unit: '',
    },
    inplay: {
        reading: 'Đang đọc',
        readingCount: '{count}',
        fontDown: 'A -',
        fontUp: 'A +',
        me: 'Tôi',
    },
    buttons: {
        next: 'Học tiếp theo',
        assign: 'Chỉ định Học sinh',
        assignStudents: 'Phân công Học sinh',
        fontSize: 'Cỡ chữ',
    },
    result: {
        done: 'Đã hoàn thành Đọc có hướng dẫn!',
        lecture: {
            all: 'Tất cả Học sinh đã đọc theo đơn vị "{readingType}".',
            split: 'Đã đọc chia nhỏ với Giáo viên theo đơn vị "{readingType}".',
            random: 'Đã đọc theo đơn vị "{readingType}" với {students}.',
            selected: 'Đã đọc theo đơn vị "{readingType}" với {students}.',
            averageTime: 'Mất {time}',
        },
        self: {
            all: 'Tất cả Học sinh đã đọc theo {readingType}.',
            split: 'Đã đọc chia nhỏ với Giáo viên theo {readingType}.',
            random: 'Đã đọc theo {readingType} với {students}.',
            selected: 'Đã đọc theo {readingType} với {students}.',
            averageTime: 'Trung bình mất {time}',
            inplay: 'Đang tiến hành "{readingMode}" theo đơn vị "{readingType}".',
        },
    },
    teacherFooter: { done: 'Đã đọc xong.', click: 'Vui lòng nhấp vào khu vực đoạn văn.' },
    pageRange: 'trang {startPage}~{endPage}',
};
